import { SemesterType } from '@app-types/index';
import { semesterToWords } from '@functions/semesterToWords';
import { HSMSSelectOption } from '@components/shared';

export const getSemestersForSelect = (): HSMSSelectOption[] => {
  return Object.keys(SemesterType).map((semester) => {
    return {
      value: semester,
      label: semesterToWords(semester),
    };
  });
};
